/**
 * Ses kapısı güvenliği (8 Eki 2026).
 *
 * Bazı sorularda şıklar ses BİTİNCE açılır. Ses dosyası yüklenemezse, oynatılamazsa ya da ağ koptuğu için
 * yarıda takılırsa "bitti" olayı hiç gelmiyor, çocuk şıkları göremeden süre doluyordu. Bu yardımcı sesi
 * oynatır ve şu durumlarda kapıyı yine de açar: oynatma reddedilirse, ses öğesi yoksa ya da ses süresi
 * (bilinmiyorsa SES_AZAMI_MS) + pay kadar zaman geçtiği halde bitmediyse.
 */
export const SES_AZAMI_MS = 25000;
const PAY_MS = 4000;

export function sesiGuvenliOynat(a: HTMLAudioElement | null, kapiyiAc: () => void): void {
  if (!a) {
    kapiyiAc();
    return;
  }
  let acildi = false;
  const ac = () => {
    if (acildi) return;
    acildi = true;
    kapiyiAc();
  };
  a.currentTime = 0;
  try {
    const p = a.play();
    if (p && typeof p.then === "function") p.catch(ac);
  } catch {
    ac();
    return;
  }
  const sure = Number.isFinite(a.duration) && a.duration > 0 ? a.duration * 1000 + PAY_MS : SES_AZAMI_MS;
  setTimeout(() => {
    if (!a.ended) ac();
  }, sure);
  a.addEventListener("ended", ac, { once: true });
}
